import { createAction, props } from '@ngrx/store';
import { SoulfileApiError } from './soulfile.errors';
import { SoulfileProject } from 'src/app/admin/models/soulfile-project.model';
import { Soulfile } from 'src/app/admin/models/soulfile.model';

export const LoadSoulfileProjects = createAction('[Soulfile] Load Soulfile Projects');

export const LoadSoulfileProjectsCsv = createAction('[Soulfile] Load Soulfile Projects Csv');

export const SetSoulfileProjects = createAction(
  '[Soulfile] Set Soulfile Projects',
  props<{ projects: SoulfileProject[] }>(),
);

export const SetSoulfileProjectsCsv = createAction('[Soulfile] Set Soulfile Projects Csv');

export const CreateSoulfileProject = createAction(
  '[Soulfile] Create Soulfile Project',
  props<{ avatarName: string }>(),
);

export const CreateSoulfileProjectWithOverride = createAction(
  '[Soulfile] Create Soulfile Project with override',
  props<{ avatarName: string; override: { [key: string]: string }[] }>(),
);

export const DeleteSoulfileProject = createAction(
  '[Soulfile] Delete Soulfile Project',
  props<{ id: number }>(),
);

export const LoadCurrentSoulfileProject = createAction(
  '[Soulfile] Load Current Soulfile Project',
  props<{ id: number }>(),
);

export const UpdateCurrentSoulfileProject = createAction(
  '[Soulfile] Update Current Soulfile Project',
  props<{ id: number; project: Partial<SoulfileProject> }>(),
);

export const SetCurrentSoulfileProject = createAction(
  '[Soulfile] Set Current Soulfile Project',
  props<{ project: SoulfileProject }>(),
);

export const LoadCurrentSoulfiles = createAction(
  '[Soulfile] Load Current Soulfiles',
  props<{ projectId: number }>(),
);

export const SetCurrentSoulfiles = createAction(
  '[Soulfile] Set Current Soulfiles',
  props<{ soulfiles: Soulfile[] }>(),
);

export const LoadCurrentSoulfile = createAction(
  '[Soulfile] Load Current Soulfile',
  props<{ soulfileId: number }>(),
);

export const SetCurrentSoulfile = createAction(
  '[Soulfile] Set Current Soulfile',
  props<{ soulfile: Soulfile }>(),
);

export const CreateSoulfile = createAction(
  '[Soulfile] Create Soulfile',
  props<{
    projectId: number;
    description: string;
    values: Record<string, unknown>;
  }>(),
);

export const SetSoulfileError = createAction(
  '[Soulfile] Set Soulfile Error',
  props<{ error: SoulfileApiError }>(),
);

export const SetSoulfileCsvError = createAction(
  '[Soulfile] Set Soulfile Error Csv',
  props<{ error: SoulfileApiError }>(),
);

export const RemoveSoulfileError = createAction('[Soulfile] Remove Soulfile Error');

export const GoToCurrentSoulfileProject = createAction(
  '[Soulfile] Go To Current Soulfile Project',
  props<{ projectId: number }>(),
);
